import { InvoicesColumns } from "@portal/BaseComponents/Table/Components/Invoices/InvoicesColumn";
import { TextWithPopoverProps } from "@portal/BaseComponents/Table/Components/Text/TextWithPopover";
import { Formats } from "@portal/hooks/use-formats";
import { DisputeList } from "@portal/types/entities/dispute";
import { cleanArrayPredicate } from "@portal/util/predicates";
import { GridColumnProps } from "@sinecycle/growcomponents";
import { useMemo } from "react";
import { getDisputeStatusDetails } from "../predicate";
import { DisputeTitle } from "./DisputeTitle/DisputeTitle";
import { OpenStatus } from "./OpenStatus/OpenStatus";

function useColumns(extra: Formats) {
  function handleColumns() {
    const columns: GridColumnProps<DisputeList> = [
      // {
      //   colId: "ID",
      //   headerComponentParams: {
      //     matchKey: "id",
      //     sorting: true,
      //   },

      //   headerName: "Dispute ID",
      //
      //   cellRenderer: DisputeID,
      //   wrapHeaderText: true,
      //   autoHeaderHeight: true,
      //   lockPosition: true,
      //   pinned: "left",
      // },
      {
        colId: "TITLE",
        headerName: "Dispute Title",
        cellRenderer: DisputeTitle,
        pinned: "left",
      },
      {
        colId: "DISPUTE_DATE",
        field: "created_at",
        headerName: "Dispute Date",
        cellRenderer: "dateCell",
        sortable: true,
        cellRendererParams: {
          dateCellProps: {
            format: extra.dateformat,
          },
        },
      },
      {
        colId: "OPEN_DAYS",
        field: "created_at",
        cellRenderer: OpenStatus,
        headerName: "Open Days",
      },
      {
        colId: "AMOUNT",
        headerName: "Dispute Amount",
        cellRenderer: "amountCell",
        field: "amount",
        cellRendererParams: {
          amountTextProps: {
            textProps: {
              strong: true,
            },
            locale: extra.locale,
          },
        },
        cellClass: "ag-right-aligned-cell",
        headerClass: "ag-right-aligned-header",
        valueGetter: (params) => {
          return {
            amount: params?.data?.amount.value,
            currency: params.data?.amount.currency,
          };
        },
      },
      {
        colId: "DISPUTE_TYPES",
        headerName: "Dispute Type",
        field: "dispute_types",
        cellRenderer: "textPopOver",
        valueGetter: (params) => {
          const disputeTypes =
            params?.data?.dispute_types.filter(cleanArrayPredicate);

          function getTypes(): TextWithPopoverProps["text"] {
            return (
              disputeTypes?.map((type) => {
                return { id: type.id, value: type.name };
              }) ?? []
            );
          }
          return getTypes();
        },
      },
      {
        colId: "DISPUTE_STATUS",
        headerName: "Dispute Status",
        cellRenderer: "statusCell",
        field: "status",
        cellRendererParams: {
          statusCellProps: {
            getter: getDisputeStatusDetails,
          },
        },
      },
      {
        colId: "ASSOCIATED_INVOICES",
        headerName: "Associated Invoice(s)",
        cellRenderer: "invoices",
        valueGetter: (params) => {
          function getInvoices(): InvoicesColumns[] {
            if (!params.data) return [];
            return params.data.invoices.map((invoice) => {
              return {
                id: invoice.id,
                title: invoice.number,
                amount: invoice.balance_due_amount,
                currency: invoice.currency,
              };
            });
          }

          return getInvoices();
        },
      },

      {
        colId: "CLOSED_DATE",
        headerName: "Closed Date",
        cellRenderer: "dateCell",
        field: "resolved_at",
        sortable: true,
        cellRendererParams: {
          dateCellProps: {
            format: extra.dateformat,
          },
        },
      },
    ];
    return columns;
  }

  const defaultColConfigs = useMemo(handleColumns, [
    extra.dateformat,
    extra.locale,
  ]);

  return { defaultColConfigs };
}

export { useColumns };
